import Icon from '../../components/Icon.vue'

Icon.register({"brands/delicious":{"width":448,"height":512,"paths":[{"d":"M446.5 68C446.1 66.5 445.6 65 445.1 63.5 444.2 61 443.1 58.7 441.8 56.4 440.4 54 438.8 51.6 437.1 49.5 435 47 432.7 44.7 430.2 42.7 429.1 41.8 428 41 426.9 40.2 425.6 39.3 424.3 38.5 422.9 37.8 421.1 36.8 419.3 36 417.4 35.3 415.7 34.6 413.9 34 412 33.6 408.2 32.6 404.1 32.1 400 32.1H48C21.5 32 0 53.5 0 80V432C0 436.1 0.5 440.2 1.5 444 3.5 451.7 7.3 458.6 12.5 464.3 13.5 465.4 14.6 466.5 15.8 467.6 21.5 472.8 28.4 476.6 36.1 478.6 39.9 479.6 44 480.1 48.1 480.1H400.1C426.6 480.1 448.1 458.6 448.1 432.1V80C448 75.9 447.5 71.8 446.5 68zM416 432C416 440.8 408.8 448 400 448H224V256H32V80C32 71.2 39.2 64 48 64H224V256H416V432z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/delicious.js
// module id = UcqX
// module chunks = 0